import React, { useContext, useEffect, useState } from 'react'
import Application from "../../StateContext/Application";
import { FileSendToBank32,BillApproved32,DemandGeneratedSuccessfully32,Time32,UpdateWhite32, Excel32, JPG32,PNG32, AddFile32, VendorName32, Bank32, barely_black_bg_img, Cancel32, Email32, Location32, PhoneNumber32, submit } from "../../../../public/LoginImages/importimages";
// const LogReport = () => {
//     const statecalls = useContext(Application);
//     const { GetLogReports } = statecalls;
//     const [reportData, SetReportData] = useState([]);
//     const [currentPage, setCurrentPage] = useState(1);
//      const [searchTerm, setSearchTerm] = useState('');
//         const billsPerPage = 10;
//     useEffect(() => {
//         GetLogReportData();
//     }, []);

//     const totalPages = Math.ceil(reportData.length / billsPerPage);
//        const indexOfLastBill = currentPage * billsPerPage;
//        const indexOfFirstBill = indexOfLastBill - billsPerPage;
//        const currentBills = reportData.slice(indexOfFirstBill, indexOfLastBill);
//     async function GetLogReportData() {
//         try {
//             let data = await GetLogReports();
//             console.log(data);

//             SetReportData(data);
//         } catch (error) {
//             console.error(error);
//         }
//     }
//     const actionIcons = {
//   "File Send To Bank": FileSendToBank32,
//   "Bill Approved": BillApproved32,
//   "Demand Generated Successfully": DemandGeneratedSuccessfully32
// };
//   return (
//         <div style={{ background: '#efecff', width: 'auto', maxHeight: "92vh", padding: 40, fontFamily: 'Inter, sans-serif' }}>
//             <div style={{ display: "grid", justifyContent: "center", boxShadow: "0 0 10px rgba(0,0,0,0.1)", borderRadius: 20, backgroundColor: "white", padding: 20, maxHeight: "81vh", overflow: "auto" }}>
//                 <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 10, padding: "0 20px", width: "100%" }}>
//                     <h5 style={{ fontWeight: "bold", color: "black", display: "flex", alignItems: "center" }}>
//                         <img src={"/Log-Reports-List-32.png"} alt="icon" style={{ marginRight: 10, width: 28, height: 28 }} /> System Log Report
//                     </h5>
//                     <div style={{ display: "flex", alignItems: "center", backgroundColor: "aliceblue", border: "1px solid #ccc", borderRadius: 5, padding: "5px 10px", width: 300 }}>
//                         <img src={"/Search-32.png"} alt="search" style={{ width: 20, height: 20, marginRight: 8 }} />
//                         <input value={searchTerm} onChange={e => setSearchTerm(e.target.value)} placeholder="Search Logs..." style={{ border: "none", outline: "none", background: "transparent", width: "100%", fontSize: 14 }} />
//                     </div>
//                 </div>

//                 <div style={{ overflowX: "auto", width: "100%" }}>
//                     <div style={{ maxHeight: "61vh", overflowY: "auto", width: "100%" }}>
//                     <table style={{ backgroundColor: "white", width: "100%", minWidth: 1200, borderCollapse: "collapse" }}>
//                         <thead >
//                             <tr style={{ backgroundColor: "#2ea4e7", color: "white", fontSize: 13, fontWeight: 600, textAlign: "left", whiteSpace: "nowrap" }}>
//                                 <th style={{ padding: 10,textAlign: "center" }}>Sr.no.</th>
//                                 <th style={{ padding: 10 }}>Action</th>
//                                 <th style={{ padding: 10 }}>Description</th>
//                                 <th style={{ padding: 10 }}>Date</th>
//                             </tr>
//                         </thead>
//                         <tbody>
//                             {currentBills &&
//                                 currentBills.map((e, index) => {
//                                     return (
//                                         <tr key={index} style={{ backgroundColor: index % 2 === 0 ? "#f4f7fe" : "white", fontSize: 13, fontWeight: 500, textAlign: "left" }}>
//                                             <td style={{height:'2rem',textAlign: "center"}}>{index + 1}</td>
//                                             <td style={{ padding: 10, display: "flex", alignItems: "center", gap: "6px" }}>
//   <img
//     src={actionIcons[e.Action] || DemandGeneratedSuccessfully32} // default fallback icon
//     alt={e.Action}
//     style={{ width: "18px", height: "18px" }}
//   />
//   <span>{e.Action}</span>
// </td>
//                                             <td style={{ padding: 10 }}>{e.Description}</td>
//                                             <td style={{ padding: 10 }}><img
//                                         src={"/Time-32.png"}
//                                         style={{ marginRight: "5px", width: "15px", height: "15px" }}
//                                     />{new Date(e.Date).toLocaleString('en-GB', {
//                                                     year: 'numeric',
//                                                     month: '2-digit',
//                                                     day: '2-digit',
//                                                     hour: '2-digit',
//                                                     minute: '2-digit',
//                                                     second: '2-digit',
//                                                     hour12: false
//                                                 }).replace(',', '')}</td>
//                                         </tr>
//                                     );
//                                 })}
//                         </tbody>
//                     </table>
//                 </div>
//                 </div>

//                 <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: 20 }}>
//                     <div>
//                         <p style={{ fontSize: 16, color: "black" }}>
//                             Showing {reportData?.length ? Math.min(indexOfFirstBill + 1, reportData?.length) : 0} to {Math.min(indexOfLastBill, reportData?.length)} of {reportData?.length} entries
//                         </p>
//                     </div>
//                     <div style={{ display: "flex",border: "1px solid #cccccc",}}>
//                         <button onClick={() => setCurrentPage(1)} disabled={currentPage === 1} style={{
//                                 padding: "8px 10px",
//                                 fontSize: "18px",
//                                 fontWeight: "bold",
//                                 width: "2rem",
//                                 height: "2.5rem",
//                                 display: "flex",
//                                 alignItems: "center",
//                                 justifyContent: "center",
//                                 backgroundColor: currentPage === 1 ? "#ffffff" : "#e5f4fb",
//                                 color: "#044c92",
                                
//                                 cursor: "pointer",
//                                 transition: "0.2s ease-in-out",
//                             }}>&laquo;</button>
//                         <button onClick={() => setCurrentPage(prev => Math.max(1, prev - 1))} disabled={currentPage === 1} style={{
//                                 padding: "8px 10px",
//                                 fontSize: "18px",
//                                 fontWeight: "bold",
//                                 width: "2rem",
//                                 height: "2.5rem",
//                                 display: "flex",
//                                 alignItems: "center",
//                                 justifyContent: "center",
//                                 backgroundColor: currentPage === 1 ? "#ffffff" : "#e5f4fb",
//                                 color: "#044c92",
//                                 // border: "1px solid #cccccc",
//                                 cursor: "pointer",
//                                 transition: "0.2s ease-in-out",
//                             }}>&lt;</button>
//                         <button style={{
//                             padding: "8px 10px",
//                             fontSize: "18px",
//                             fontWeight: "bold",
//                             width: "2rem",
//                             height: "2.5rem",
//                             display: "flex",
//                             alignItems: "center",
//                             justifyContent: "center",
//                             background: "linear-gradient(to bottom, #044c92 , #0071bc , #022f5a )",
//                             color: "white",
//                             // border: "1px solid #cccccc",
//                         }}>{currentPage}</button>
//                         <button onClick={() => setCurrentPage(prev => Math.min(totalPages || 1, prev + 1))} disabled={currentPage === totalPages} style={{
//                                 padding: "8px 10px",
//                                 fontSize: "18px",
//                                 fontWeight: "bold",
//                                 width: "2rem",
//                                 height: "2.5rem",
//                                 display: "flex",
//                                 alignItems: "center",
//                                 justifyContent: "center",
//                                 backgroundColor: currentPage === totalPages ? "#ffffff" : "#e5f4fb",
//                                 color: "#044c92",
//                                 // border: "1px solid #cccccc",
//                                 cursor: "pointer",
//                                 transition: "0.2s ease-in-out",
//                             }}>&gt;</button>
//                         <button onClick={() => setCurrentPage(totalPages)} disabled={currentPage === totalPages} style={{
//                                 padding: "8px 10px",
//                                 fontSize: "18px",
//                                 fontWeight: "bold",
//                                 width: "2rem",
//                                 height: "2.5rem",
//                                 display: "flex",
//                                 alignItems: "center",
//                                 justifyContent: "center",
//                                 backgroundColor: currentPage === totalPages ? "#ffffff" : "#e5f4fb",
//                                 color: "#044c92",
//                                 // border: "1px solid #cccccc",
//                                 cursor: "pointer",
//                                 transition: "0.2s ease-in-out",
//                             }}>&raquo;</button>
//                     </div>
//                 </div>
//             </div>
//         </div>
//     )
// }
const LogReport = () => {
  const statecalls = useContext(Application);
  const { GetLogReports } = statecalls;
  const [reportData, SetReportData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const billsPerPage = 10;
  useEffect(() => {
    GetLogReportData();
  }, []);

  
  // 01-10 for serach
   // ================= SEARCH =================
const filteredReportData = reportData.filter((item) => {
    const search = searchTerm.toLowerCase().trim();
 
    return (
        String(item.Action || "").toLowerCase().includes(search) ||
        String(item.Description || "").toLowerCase().includes(search) ||
        String(item.Date || "").toLowerCase().includes(search)
    );
});
 

  // const totalPages = Math.ceil(reportData.length / billsPerPage);
  // const indexOfLastBill = currentPage * billsPerPage;
  // const indexOfFirstBill = indexOfLastBill - billsPerPage;
  // const currentBills = reportData.slice(indexOfFirstBill, indexOfLastBill);
 // 01-10
  const totalPages = Math.ceil(filteredReportData.length / billsPerPage);

const indexOfLastBill = currentPage * billsPerPage;
const indexOfFirstBill = indexOfLastBill - billsPerPage;

const currentBills = filteredReportData.slice(
  indexOfFirstBill,
  indexOfLastBill
);
  async function GetLogReportData() {
    try {
      let data = await GetLogReports();
      console.log(data);

      SetReportData(data);
    } catch (error) {
      console.error(error);
    }
  }
  const actionIcons = {
    "File Send To Bank": FileSendToBank32,
    "Bill Approved": BillApproved32,
    "Demand Generated Successfully": DemandGeneratedSuccessfully32,
  };

  const getLogReportPageNumbers = () => {
    const maxVisiblePages = 5;

    if (totalPages <= maxVisiblePages) {
      return Array.from({ length: totalPages }, (_, index) => index + 1);
    }

    // Page 1, 2, 3
    if (currentPage <= 3) {
      return [1, 2, 3, 4, 5, "...", totalPages];
    }

    // Last pages
    if (currentPage >= totalPages - 2) {
      return [
        "...",
        totalPages - 4,
        totalPages - 3,
        totalPages - 2,
        totalPages - 1,
        totalPages,
      ];
    }

    // Middle pages
    return [
      "...",
      currentPage - 2,
      currentPage - 1,
      currentPage,
      currentPage + 1,
      currentPage + 2,
      "...",
      totalPages,
    ];
  };

 return (
    //2/11
   <div
  style={{
    width: "100%",
    maxWidth: "1000px",
    margin: "14px auto 0",
    background: "#EEF2F7",
    border: "1px solid #dfe5ee",
    borderRadius: "10px",
    padding: "15px 20px 20px",
    boxSizing: "border-box",
    marginTop:"20px",
    height:"90vh",
    minHeight:"93vh"
  }}
>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: 10,
          padding: "0 20px",
          width: "100%",
        }}
      >
        <h5
          style={{
            fontWeight: "bold",
            color: "black",
            display: "flex",
            alignItems: "center",
          }}
        >
          <img
            src={"/Log-Reports-List-32.png"}
            alt="icon"
            style={{ marginRight: 10, width: 28, height: 28 }}
          />{" "}
          System Log Report
        </h5>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            backgroundColor: "white",
            border: "1px solid #ccc",
            borderRadius: 5,
            padding: "5px 10px",
            width: 300,
          }}
        >
          <img
            src={"/Search-32.png"}
            alt="search"
            style={{ width: 20, height: 20, marginRight: 8 }}
          />
          <input
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            placeholder="Search Logs..."
            style={{
              border: "none",
              outline: "none",
              background: "transparent",
              width: "100%",
              fontSize: 14,
            }}
          />
        </div>
      </div>
      <div
        style={{
          display: "grid",
          justifyContent: "center",
          boxShadow: "0 0 10px rgba(0,0,0,0.1)",
          borderRadius: 20,
          backgroundColor: "white",
          padding: 20,
          maxHeight: "81vh",
          overflow: "auto",
        }}
      >
        <div style={{ overflowX: "auto", width: "100%" }}>
          {/* //28/10 */}
         <div
  style={{
    overflowX: "auto",
    width: "100%",
    border: "1px solid #d9e1f2",   
    borderRadius: "8px",          
    boxSizing: "border-box",
  }}
>
  {/* //28/10 */}
            <table
              style={{
      backgroundColor: "white",
      width: "100%",
      minWidth: "70vw",
      borderCollapse: "separate",  
      borderSpacing: 0,            
    
    }}
            >
              <thead>
                <tr
                //28/10
                  style={{
                    backgroundColor: "#2D79D9",
                    color: "white",
                    fontSize: 14,
                    fontWeight: 600,
                    textAlign: "left",
                    whiteSpace: "nowrap",
                  }}
                >
                  {/* //23/10 */}
                  <th style={{ padding: "10px 8px", textAlign: "center", border: "1px solid #d2ddf5" }}>Sr.no.</th>
                  <th style={{ padding: "10px 8px", textAlign: "center", border: "1px solid #d2ddf5" }}>Action</th>
                  <th style={{ padding: "10px 8px", textAlign: "center", border: "1px solid #d2ddf5" }}>Description</th>
                  <th style={{ padding: "10px 8px", textAlign: "center", border: "1px solid #d2ddf5" }}>Date</th>
                </tr>
              </thead>
              <tbody>
                {currentBills &&
                  currentBills.map((e, index) => {
                    return (
                      <tr
                        key={index}
                        style={{
                          //28/10
                          backgroundColor:
                            index % 2 === 0 ? "#E5F4FB" : "#CEE4F1",
                          fontSize: 13,
                          fontWeight: 500,
                          textAlign: "left",
                        }}
                      >
                        <td style={{ height: "2rem", textAlign: "center" }}>
                          {indexOfFirstBill + index + 1}
                        </td>
                        {/* //23/10 */}
                        <td style={{ padding: "10px", border: "1px solid #d2ddf5", alignItems: "center", verticalAlign: "middle" }}>
                           <div style={{  display: "flex", alignItems: "center", justifyContent: "center", gap: "6px" }}>
                          <img
                            src={
                              actionIcons[e.Action] ||
                              DemandGeneratedSuccessfully32
                            } // default fallback icon
                            alt={e.Action}
                            style={{ width: "18px", height: "18px" }}
                          />
                          <span>{e.Action}</span>
                          </div>
                        </td>
                        {/* //23/10 */}
                        <td style={{ padding: "5px 8px", border: "1px solid #d2ddf5" }}>{e.Description}</td>
                        <td style={{ padding: "5px 8px", border: "1px solid #d2ddf5" }}>
                          <img
                            src={"/Time-32.png"}
                            style={{
                              marginRight: "5px",
                              width: "15px",
                              height: "15px",
                            }}
                          />
                          {new Date(e.Date)
                            .toLocaleString("en-GB", {
                              year: "numeric",
                              month: "2-digit",
                              day: "2-digit",
                              hour: "2-digit",
                              minute: "2-digit",
                              second: "2-digit",
                              hour12: false,
                            })
                            .replace(",", "")}
                        </td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
            {/* 30-09 */}
        {(!Array.isArray(currentBills) || currentBills.length === 0) && (
                    <div
                      style={{
                        position: "sticky",
                        left: 0,
                        width: "100%",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        height: "150px",
                        boxSizing: "border-box",
                        backgroundColor: "#f9f9f9",
                        color: "black",
                        fontSize: "15px",
                        fontWeight: 500,
                      }}
                    >
                      No data available
                    </div>
                  )}
 
          </div>
        </div>

        <div
          style={{
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            marginTop: "15px",
            padding: "10px 5px",
            boxSizing: "border-box",
          }}
        >
          {/* Showing Entries */}
          <div
            style={{
              fontSize: "13px",
              color: "#333",
              whiteSpace: "nowrap",
            }}
          >
            {/* Showing {reportData?.length === 0 ? 0 : indexOfFirstBill + 1} to{" "}
            {Math.min(indexOfLastBill, reportData?.length || 0)} of{" "}
            {reportData?.length || 0} entries */}
            {/* 01-10 for search */}
             Showing{" "}
{filteredReportData.length === 0
    ? 0
    : indexOfFirstBill + 1}{" "}
to{" "}
{Math.min(
    indexOfLastBill,
    filteredReportData.length
)}{" "}
of {filteredReportData.length} entries
 
          </div>

          {/* Pagination */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "18px",
            }}
          >
            {/* Previous */}
            <button
              onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
              disabled={currentPage === 1}
              style={{
                border: "none",
                background: "transparent",
                color: "#2ea4e7",
                cursor: currentPage === 1 ? "not-allowed" : "pointer",
                fontSize: "12px",
                padding: 0,
                opacity: currentPage === 1 ? 0.5 : 1,
              }}
            >
              ‹ Previous
            </button>

            {/* Page Numbers */}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "20px",
              }}
            >
              {getLogReportPageNumbers().map((pageNumber, index) => {
                if (pageNumber === "...") {
                  return (
                    <span
                      key={`log-dots-${index}`}
                      style={{
                        fontSize: "13px",
                        color: "#444",
                      }}
                    >
                      ...
                    </span>
                  );
                }

                return (
                  <button
                    key={pageNumber}
                    onClick={() => setCurrentPage(pageNumber)}
                    style={{
                      border: "none",
                      background: "transparent",
                      padding: 0,
                      color: currentPage === pageNumber ? "#2ea4e7" : "#444",
                      cursor: "pointer",
                      fontSize: "13px",
                      fontWeight: currentPage === pageNumber ? "600" : "400",
                      textDecoration:
                        currentPage === pageNumber ? "underline" : "none",
                    }}
                  >
                    {pageNumber}
                  </button>
                );
              })}
            </div>

            {/* Next */}
            <button
              onClick={() =>
                setCurrentPage((prev) => Math.min(prev + 1, totalPages))
              }
              disabled={currentPage === totalPages || totalPages === 0}
              style={{
                border: "none",
                background: "transparent",
                color: "#2ea4e7",
                cursor:
                  currentPage === totalPages || totalPages === 0
                    ? "not-allowed"
                    : "pointer",
                fontSize: "12px",
                padding: 0,
                opacity:
                  currentPage === totalPages || totalPages === 0 ? 0.5 : 1,
              }}
            >
              Next ›
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LogReport
